export const environment = {
  production: false,
  onlineColoApiUrl: 'https://devcolo.verticalbridge.com/api',
  onlineColoUrl: 'https://devcolo.verticalbridge.com',
  partnerPortalApiUrl: 'https://devpartnerportal.verticalbridge.com/api',
  partnerPortalUrl: 'https://devpartnerportal.verticalbridge.com',
  verticalIntelApiUrl: 'https://devverticalintel.verticalbridge.com/api',
  verticalIntelUrl: 'https://devverticalintel.verticalbridge.com',
  siteLocatorUrl: 'https://dev-sitelocator-epfug9bhhcbqfth2.eastus-01.azurewebsites.net',
  verticalWorksUrl: 'https://devverticalworks.verticalbridge.com',
  verticalWorksApiUrl: 'https://devverticalworks.verticalbridge.com/api',
  contactUrl: 'https://www.verticalbridge.com/contact',
  appInsights: {
    instrumentationKey: ''
  },
  auth0: {
    domain: 'onlinecolostage.us.auth0.com',
    clientId: '86cwRWJZPSxmoW6or3SOzMhC697DSP4U',
    audience: 'onlinecolo-dev-api',
    redirectUri: window.location.origin,
    scope: 'openid profile email offline_access read:current_user update:current_user_metadata read:user',
    useRefreshTokens: true,
    cacheLocation: 'localstorage' as const,
    connection: 'Online-Colo-AD'
  }
};
